<app-alert *ngIf="alertVisible" type="warning">
  <ng-container alert-title>{{ 'timezone-notifier.title' | translate }}</ng-container>
  <ng-container alert-body>
    {{ 'timezone-notifier.question' | translate: { timezone: browserTimezone, offset: browserTimezoneOffset } }}
  </ng-container>
  <ng-container alert-buttons>
    <on-ui-button label="timezone-notifier.btn-skip"
                  class="primary outline"
                  (onclick)="skip()">
    </on-ui-button>
    <on-ui-button label="timezone-notifier.btn-save"
                  class="primary"
                  (onclick)="save()">
    </on-ui-button>
  </ng-container>
</app-alert>
